/* unplugin-vue-components disabled */import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "setup_box"
};
import { ElMessage } from 'element-plus';
import { watch } from 'vue';
export default {
  __name: 'stepOrder',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var count = ref(0);
    watch(() => {
      return props.modelValue;
    }, val => {
      console.log('打印val====', val);
      count.value = props.modelValue;
    }, {
      immediate: true
    });
    var handlejian = () => {
      if (count.value < 2) {
        ElMessage({
          type: 'warning',
          message: '最小数量为1'
        });
        return false;
      }
      count.value = Number(count.value) - 1;
    };
    var handlejia = () => {
      count.value = Number(count.value) + 1;
    };
    watch(() => {
      return count.value;
    }, () => {
      emit('update:modelValue', count.value);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "jian",
        onClick: handlejian
      }, _cache[1] || (_cache[1] = [_createElementVNode("span", {
        class: "iconfont icon-jian"
      }, null, -1)])), _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(count) ? count.value = $event : null)
      }, null, 512), [[_vModelText, _unref(count)]]), _createElementVNode("div", {
        class: "jia",
        onClick: handlejia
      }, _cache[2] || (_cache[2] = [_createElementVNode("span", {
        class: "iconfont icon-tianjia"
      }, null, -1)]))]);
    };
  }
};